import store from "@/store";
import utils from "@/utils";
import {
  DATA_ELEMENT_TYPE,
  MUTATION_NAME,
  TRANSLATION_TAG
} from "@/static/global-variables";

function _hasValidExpreesionData(type, dataType, data) {
  let isValid = true;
  if (!type) {
    console.error(
      `Error type must have a value - type: ${type}, dataType: ${dataType}, data: `,
      JSON.stringify(data)
    );
    isValid = false;
  }
  if (!dataType) {
    console.error(
      `Error dataType must have a value - type: ${type}, dataType: ${dataType}, data: `,
      JSON.stringify(data)
    );
    isValid = false;
  }
  if (!data || !Object.keys(data).length) {
    console.error(
      `Error data must have a value - type: ${type}, dataType: ${dataType}, data: `,
      JSON.stringify(data)
    );
    isValid = false;
  }
  return isValid;
}

class ExpressionBuilder {
  constructor() {
    this.listOfRecords = [
      DATA_ELEMENT_TYPE.CRM_QUERY, // when no dataElement.limit !== 1 otherwise is considered singleton if dataElement.limit === 1
      DATA_ELEMENT_TYPE.NITRO_QUERY,
      DATA_ELEMENT_TYPE.ONE_FOR_ONE,
      DATA_ELEMENT_TYPE.CRM_DATA_ENGINE,
      DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES,
      DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS,
      DATA_ELEMENT_TYPE.CALL_ATTENDEES
    ];

    // listDataElements where original source can be any listOfRecords
    // or orignal source can be any listDataElements that eventually have the original source to any listOfRecords
    this.listDataElements = [
      DATA_ELEMENT_TYPE.SORT_LIST,
      DATA_ELEMENT_TYPE.FILTER_LIST,
      DATA_ELEMENT_TYPE.SUBLIST,
      DATA_ELEMENT_TYPE.MERGE_LIST,
      DATA_ELEMENT_TYPE.SALES_DATA_QUERY,
      DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA,
      DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS
    ];

    this.singletonDataSource = [
      DATA_ELEMENT_TYPE.TODAY,
      DATA_ELEMENT_TYPE.NOW,
      DATA_ELEMENT_TYPE.CONTEXT_QUERY,
      DATA_ELEMENT_TYPE.SUMMARIZE,
      DATA_ELEMENT_TYPE.OBJECT_TRANSLATION,
      DATA_ELEMENT_TYPE.FIELD_TRANSLATION,
      DATA_ELEMENT_TYPE.VEEVA_MESSAGES,
      DATA_ELEMENT_TYPE.DROPDOWN,
      DATA_ELEMENT_TYPE.FEEDBACK_OVERVIEW
    ];

    this.singletonTranslationDataSource = [
      DATA_ELEMENT_TYPE.OBJECT_TRANSLATION,
      DATA_ELEMENT_TYPE.FIELD_TRANSLATION,
      DATA_ELEMENT_TYPE.VEEVA_MESSAGES
    ];

    this.LEVEL_TYPE = {
      TOP: 2,
      SECOND: 3
    };

    this.EXPRESSION_TYPE = {
      SINGLETON_FIELD: "singleton field",
      LOCAL_FIELD: "local field",
      COUNT_UNIQUE: "count unique",
      SUM: "sum",
      PRODUCT: "product",
      ROUND_NUMBER: "round number",
      DATE_YEAR: "date year",
      DATE_MONTH: "date month",
      DATE_DAY_IN_MONTH: "date day in month",
      PICK_ONE: "pick one",
      MAX: "max",
      MIN: "min",
      NOT: "not",
      ALL: "all",
      ANY: "any",
      LIST_OF_EXPRESSIONS: "list of expressions",
      ADD_NUMBER: "add number",
      SUBTRACT_NUMBER: "subtract number",
      MULTIPLY_NUMBER: "multiply number",
      DIVIDE_NUMBER: "divide number",
      IN: "in",
      NOT_IN: "not in",
      FORMAT_DATE: "format date",
      CONCAT: "concat",
      DATE_FLOOR: "date floor",
      DATE_CEILING: "date ceiling",
      DATE_ADDITION: "date addition",
      DATE_SUBTRACTION: "date subtraction",
      EQUAL: "equal",
      NOT_EQUAL: "not equal",
      LT: "lt",
      LTE: "lte",
      GT: "gt",
      GTE: "gte",
      NUMBER_TO_STRING: "number to string",
      IF: "if",
      FIELD_IN_LIST: "field in list",
      RELATED_FIELD: "related field",
      STATIC: "static",
      STRING: "string",
      INT: "int",
      FLOAT: "float",
      NUMBER: "number",
      DATE: "date",
      BOOLEAN: "bool",
      IS_NULL: "is null",
      IS_NOT_NULL: "is not null"
    };
  }

  isListOfRecords(de) {
    let isListRecords = de ? this.listOfRecords.includes(de.type) : false;
    if (isListRecords) {
      if (
        de.type === DATA_ELEMENT_TYPE.CRM_QUERY ||
        de.type === DATA_ELEMENT_TYPE.NITRO_QUERY ||
        de.type === DATA_ELEMENT_TYPE.CRM_DATA_ENGINE
      ) {
        isListRecords = de.limit !== 1;
      }
    }
    return isListRecords;
  }

  isListDataElement(de) {
    return de ? this.listDataElements.includes(de.type) : false;
  }

  isSingletonDataSource(de) {
    return de ? this.singletonDataSource.includes(de.type) : false;
  }

  isSingletonTranslationDataSource(de) {
    return de ? this.singletonTranslationDataSource.includes(de.type) : false;
  }

  getExpression(type, dataType, data) {
    if (_hasValidExpreesionData(type, dataType, data)) {
      type = type.toLowerCase();
      dataType = dataType.toLowerCase();
      switch (type) {
        case this.EXPRESSION_TYPE.COUNT_UNIQUE:
        case this.EXPRESSION_TYPE.SUM:
        case this.EXPRESSION_TYPE.PRODUCT:
        case this.EXPRESSION_TYPE.ROUND_NUMBER:
        case this.EXPRESSION_TYPE.DATE_YEAR:
        case this.EXPRESSION_TYPE.DATE_MONTH:
        case this.EXPRESSION_TYPE.DATE_DAY_IN_MONTH:
        case this.EXPRESSION_TYPE.PICK_ONE:
        case this.EXPRESSION_TYPE.MAX:
        case this.EXPRESSION_TYPE.MIN:
        case this.EXPRESSION_TYPE.NOT:
        case this.EXPRESSION_TYPE.ALL:
        case this.EXPRESSION_TYPE.ANY:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            expression: data.expression //sub-expression goes here
          };

        case this.EXPRESSION_TYPE.LIST_OF_EXPRESSIONS:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive. depends on sub-expressions
            expressions: data.expressions //sub-expression goes here
          };

        case this.EXPRESSION_TYPE.ADD_NUMBER:
        case this.EXPRESSION_TYPE.SUBTRACT_NUMBER:
        case this.EXPRESSION_TYPE.MULTIPLY_NUMBER:
        case this.EXPRESSION_TYPE.DIVIDE_NUMBER:
        case this.EXPRESSION_TYPE.IN:
        case this.EXPRESSION_TYPE.NOT_IN:
          return {
            type: type, // case insensitive
            dataType: dataType, // or "Float", case insensitive
            expression1: data.expression1, // sub-expression goes here
            expression2: data.expression2 // sub-expression 2 goes here
          };
        case this.EXPRESSION_TYPE.DATE_ADDITION:
        case this.EXPRESSION_TYPE.DATE_SUBTRACTION:
          return {
            type: type, // case insensitive
            dataType: dataType, // or "Float", case insensitive
            expression1: data.expression1, // sub-expression goes here
            expression2: data.expression2, // sub-expression 2 goes here
            dateUnit: data.dateUnit // Days or Weeks, Months, Years
          };
        case this.EXPRESSION_TYPE.FORMAT_DATE:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            dateExpression: data.dateExpression, // date sub-expression goes here
            formatExpression: data.formatExpression // format string sub-expression goes here
          };
        case this.EXPRESSION_TYPE.CONCAT:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            listExpression: data.listExpression, // list sub-expression goes here
            joinExpression: data.joinExpression // string sub-expression goes here
          };
        case this.EXPRESSION_TYPE.DATE_FLOOR:
        case this.EXPRESSION_TYPE.DATE_CEILING:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            expression: data.expression, // sub-expression goes here
            dateInterval: data.dateInterval // or Month, Quarter, Year
          };
        case this.EXPRESSION_TYPE.EQUAL:
        case this.EXPRESSION_TYPE.NOT_EQUAL:
        case this.EXPRESSION_TYPE.LT:
        case this.EXPRESSION_TYPE.LTE:
        case this.EXPRESSION_TYPE.GT:
        case this.EXPRESSION_TYPE.GTE:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            expression1: data.expression1, // sub-expression goes here
            expression2: data.expression2, // sub-expression 2 goes here
            inputDataType: data.inputDataType // or whatever. This is the data type of the two sub-expressions
          };
        case this.EXPRESSION_TYPE.NUMBER_TO_STRING:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive
            expression: data.expression, // sub-expression goes here
            decimals: data.decimals // user input
          };
        case this.EXPRESSION_TYPE.IF:
          return {
            type: type, // case insensitive
            dataType: dataType, // Or whatever. case insensitive. based on data type of thenExpression and elseExpression
            ifExpression: data.ifExpression, // sub-expression goes here
            thenExpression: data.thenExpression, // sub-expression goes here
            elseExpression: data.elseExpression // sub-expression goes here
          };
        case this.EXPRESSION_TYPE.FIELD_IN_LIST:
        case this.EXPRESSION_TYPE.SINGLETON_FIELD:
          return {
            type: type, // case insensitive
            dataType: dataType, // case insensitive. depends on the data type of the field
            dataElement: data.dataElement, // uuid-of-data-element-to-get-field-from
            field: data.field,
            value: data.value,
            label: data.label
          };
        case this.EXPRESSION_TYPE.RELATED_FIELD:
          if (data.expression) {
            // already formatted, just returning data.expression
            return data.expression;
          }
          return {
            type: type,
            dataType: dataType, // The data type of the "Get {{X}}" field
            field: data.field, // "GET {{X}}" Must be a field from the related data element
            relationship: data.relationship
            // relationship: {
            //   nextElement: "uuid-of-data-element", // this is the related data element
            //   idToMatch: {}, // "Where {{Y}}" The local expression object goes here. Local to nextElement
            //   localIds: {}, // "Matches {{Z}}" A local string list expression. Local to the parent context
            //   filterBy: null // "Filter By {{AA}}" A local bool expression. Local to nextElement. Optional.
            // }
          };
        case this.EXPRESSION_TYPE.STATIC:
          return {
            type: type, // case insensitive
            dataType: dataType, // or whatever. based on the selected field
            value: data.value,
            label: data.label
          };
        case this.EXPRESSION_TYPE.LOCAL_FIELD:
        case this.EXPRESSION_TYPE.STRING:
          return {
            type: type, // case insensitive
            dataType: dataType, // or whatever. based on the selected field
            field: data.field,
            value: data.value,
            label: data.label
          };
        //add other cases
      }
    }
  }

  getStaticNumberExpression(data) {
    return this.getExpression(
      this.EXPRESSION_TYPE.STATIC,
      this.EXPRESSION_TYPE.NUMBER,
      data
    );
  }

  getStaticDateExpression(data) {
    return this.getExpression(
      this.EXPRESSION_TYPE.STATIC,
      this.EXPRESSION_TYPE.DATE,
      data
    );
  }
  getStaticStringExpression(data) {
    return this.getExpression(
      this.EXPRESSION_TYPE.STATIC,
      this.EXPRESSION_TYPE.STRING,
      data
    );
  }
  getStaticBooleanExpression(data) {
    return this.getExpression(
      this.EXPRESSION_TYPE.STATIC,
      this.EXPRESSION_TYPE.BOOLEAN,
      data
    );
  }
  getStaticExpression(dataType, data) {
    return this.getExpression(this.EXPRESSION_TYPE.STATIC, dataType, data);
  }

  // Helper functions for displaying data
  parseArrayAllLocalExpressions(dataElement, sources, id) {
    return this.parseAllLocalExpressions(dataElement, sources, id).expressions;
  }
  parseAllLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.ALL
    );
  }
  parseArrayStringLocalExpressions(dataElement, sources, id) {
    return this.parseStringLocalExpressions(dataElement, sources, id)
      .expressions;
  }
  parseStringLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.STRING
    );
  }

  parseArrayIntAndFloatLocalExpressions(dataElement, sources, id) {
    return this.parseIntLocalExpressions(
      dataElement,
      sources,
      id
    ).expressions.concat(
      this.parseFloatLocalExpressions(dataElement, sources, id).expressions
    );
  }
  parseIntLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.INT
    );
  }

  parseFloatLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.FLOAT
    );
  }

  parseArrayBooleanLocalExpressions(dataElement, sources, id) {
    return this.parseBooleanLocalExpressions(dataElement, sources, id)
      .expressions;
  }
  parseBooleanLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.BOOLEAN
    );
  }

  parseArrayNumberLocalExpressions(dataElement, sources, id) {
    return this.parseNumberLocalExpressions(dataElement, sources, id)
      .expressions;
  }
  parseNumberLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.NUMBER
    );
  }

  parseArrayDateLocalExpressions(dataElement, sources, id) {
    return this.parseDateLocalExpressions(dataElement, sources, id).expressions;
  }
  parseDateLocalExpressions(dataElement, sources, id) {
    return this.parseLocalExpressions(
      dataElement,
      sources,
      id,
      this.EXPRESSION_TYPE.DATE
    );
  }
  parseLocalExpressions(de, sources, id, expType) {
    const el = {
      expressions: []
    };
    id = id || 0;
    const isListDataElement = this.isListDataElement(de);
    if (sources && de && isListDataElement) {
      this.appendOriginalDataSourceFields(sources, de);
    }
    if (de && de.id && de.fields) {
      const dataElement = { ...de };
      const original = sources ? sources[dataElement.original] : undefined;
      el.name = dataElement.name;
      for (const [prop, obj] of Object.entries(dataElement.fields)) {
        if (
          expType === this.EXPRESSION_TYPE.ALL ||
          obj.dataType.toLowerCase() === expType.toLowerCase()
        ) {
          let exp;
          if (
            original &&
            dataElement.type === DATA_ELEMENT_TYPE.ONE_FOR_ONE &&
            !isListDataElement
          ) {
            // get existing expressions from DATA_EL_ONE_FOR_ONE
            exp = { ...obj };
            // make sure they are lowercase to avoid issues
            exp.type = exp.type.toLowerCase();
            exp.dataType = exp.dataType.toLowerCase();
            exp.label = prop;
            if (exp.type === this.EXPRESSION_TYPE.LOCAL_FIELD) {
              exp.referToElem = original.id;
              if (!exp.convertedFromStatic) {
                exp.value = `${original.name} -> ${exp.field}`;
              } else {
                let hasField = !dataElement.searchBoxId
                  ? original.fields[exp.label]
                  : dataElement.fields[exp.label];
                if (hasField && exp.field !== exp.label) {
                  exp.field = exp.label;
                }
                exp.value = `${dataElement.name} -> ${exp.label}`;
              }
            } else if (
              exp.type === this.EXPRESSION_TYPE.STATIC &&
              original &&
              dataElement.searchBoxId
            ) {
              exp = this.getExpression(
                this.EXPRESSION_TYPE.LOCAL_FIELD,
                obj.dataType,
                { field: prop }
              );
              exp.label = obj.label || prop;
              exp.value = `${original.name} -> ${prop}`;
              exp.referToElem = original.id;
              exp.convertedFromStatic = true;
            }
          } else {
            const p = this.getFieldNameForExpression(de, obj, prop);

            exp = this.getExpression(
              this.EXPRESSION_TYPE.LOCAL_FIELD,
              obj.dataType,
              { field: p }
            );
            exp.label = exp.field || obj.label;
            exp.value = `${dataElement.name} -> ${p}`;
            exp.referToElem = dataElement.id;
          }
          exp.id = ++id;
          el.expressions.push(exp);
        }
      }
    }
    return el;
  }

  getFieldNameForExpression(de, obj, prop) {
    if (de.type === DATA_ELEMENT_TYPE.CRM_DATA_ENGINE) {
      return obj.as ? obj.as : obj.field;
    }
    return prop;
  }

  parseArrayNumberGlobalExpressions(dataElements, id) {
    return this.parseArrayGlobalExpressions(
      dataElements,
      this.EXPRESSION_TYPE.NUMBER,
      id
    );
  }

  parseArrayDateGlobalExpressions(dataElements, id) {
    return this.parseArrayGlobalExpressions(
      dataElements,
      this.EXPRESSION_TYPE.DATE,
      id
    );
  }
  parseArrayStringGlobalExpressions(dataElements, id) {
    return this.parseArrayGlobalExpressions(
      dataElements,
      this.EXPRESSION_TYPE.STRING,
      id
    );
  }
  parseArrayBooleanGlobalExpressions(dataElements, id) {
    return this.parseArrayGlobalExpressions(
      dataElements,
      this.EXPRESSION_TYPE.BOOLEAN,
      id
    );
  }

  parseArrayGlobalExpressions(dataElements, dataType, id) {
    let globalExpressions = [];
    id = id || 100;
    if (dataElements) {
      const globExpObject = this.parseGlobalExpressions(
        dataElements,
        dataType,
        id
      );
      for (const [, obj] of Object.entries(globExpObject)) {
        globalExpressions = [...globalExpressions, ...obj.expressions];
      }
    }
    return globalExpressions;
  }

  parseGlobalExpressions(
    dataElements,
    dataType = this.EXPRESSION_TYPE.STRING,
    id
  ) {
    const expressions = {};
    id = id || 100;
    if (dataElements) {
      for (const [key, dataElement] of Object.entries(dataElements)) {
        const el = {
          name: dataElement.name,
          expressions: []
        };
        if (this.isSingletonDataSource(dataElement)) {
          if (dataElement.type === DATA_ELEMENT_TYPE.VEEVA_MESSAGES) {
            if (dataType === this.EXPRESSION_TYPE.STRING) {
              // Veeva Messages data element - Make sure to only parse it when dataType === string
              dataElement.messages.forEach(msg => {
                const fieldName = `${msg.name};;${msg.category}`;

                const data = {
                  field: fieldName,
                  dataElement: key
                };
                const exp = this.getExpression(
                  this.EXPRESSION_TYPE.SINGLETON_FIELD,
                  this.EXPRESSION_TYPE.STRING,
                  data
                );
                exp.id = ++id;
                exp.value = `${dataElement.name} -> ${fieldName}`;
                exp.referToElem = dataElement.id;
                exp.label = fieldName;
                el.expressions.push(exp);
                expressions[key] = el;
              });
            }
          } else if (dataElement.fields) {
            if (this.isSingletonTranslationDataSource(dataElement)) {
              // Object Translation and Field Translation data elements
              if (dataType === this.EXPRESSION_TYPE.STRING) {
                // Make sure to only parse it when dataType === string
                for (const [k] of Object.entries(dataElement.fields)) {
                  const data = {
                    field: k,
                    dataElement: key
                  };
                  const exp = this.getExpression(
                    this.EXPRESSION_TYPE.SINGLETON_FIELD,
                    this.EXPRESSION_TYPE.STRING,
                    data
                  );
                  exp.id = ++id;
                  exp.referToElem = dataElement.id;
                  exp.value = `${dataElement.name} -> ${k}`;
                  exp.label = k;
                  el.expressions.push(exp);
                  expressions[key] = el;
                }
              }
            } else {
              if (dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_OVERVIEW) {
                this.updateSelectedFieldsToFieldsDict(dataElement);
              }
              for (const [k, v] of Object.entries(dataElement.fields)) {
                // Context queries - always singletons
                if (v.dataType.toLowerCase() === dataType) {
                  const data = {
                    field: k,
                    dataElement: key
                  };
                  const exp = this.getExpression(
                    this.EXPRESSION_TYPE.SINGLETON_FIELD,
                    v.dataType,
                    data
                  );
                  exp.id = ++id;
                  exp.referToElem = dataElement.id;
                  exp.value = `${dataElement.name} -> ${k}`;
                  exp.label = k;
                  el.expressions.push(exp);
                  expressions[key] = el;
                }
              }
            }
          }
        } else if (dataElement.limit === 1 && dataElement.fields) {
          // CRM queries - when limit === 1 will be considered singleton
          for (const [prop, obj] of Object.entries(dataElement.fields)) {
            if (obj.dataType.toLowerCase() === dataType) {
              const data = {
                field: prop,
                dataElement: key
              };
              const exp = this.getExpression(
                this.EXPRESSION_TYPE.SINGLETON_FIELD,
                obj.dataType,
                data
              );
              exp.id = ++id;
              exp.referToElem = dataElement.id;
              exp.value = `${dataElement.name} -> ${prop}`;
              exp.label = obj.label;
              el.expressions.push(exp);
            }
          }
          expressions[key] = el;
        }
      }
    }
    return expressions;
  }

  filterGlobalSources(allSources, dataSource) {
    dataSource = dataSource || {};
    const dataSourcesList = [];
    if (allSources) {
      for (const dataElement of Object.values(allSources)) {
        if (
          (dataElement.id !== dataSource.id &&
            this.isListDataElement(dataElement)) ||
          this.isListOfRecords(dataElement)
        ) {
          const dataElementClone = JSON.parse(JSON.stringify(dataElement)); //{ ...dataElement };
          if (this.isListDataElement(dataElementClone)) {
            this.appendOriginalDataSourceFields(allSources, dataElementClone);
          } else if (
            dataElementClone.type === DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES
          ) {
            this.appendStaticDataElementDataSourceFields(
              dataElementClone,
              DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES
            );
          } else if (
            dataElementClone.type === DATA_ELEMENT_TYPE.CALL_ATTENDEES
          ) {
            this.appendStaticDataElementDataSourceFields(
              dataElementClone,
              DATA_ELEMENT_TYPE.CALL_ATTENDEES
            );
          }
          this.appendCRMPicklistTranslations(allSources, dataElementClone);
          dataElementClone.label = dataElementClone.name;
          dataSourcesList.push(dataElementClone);
        }
      }
    }
    return dataSourcesList;
  }

  appendCRMPicklistTranslations(allSources, dataElement) {
    let originalDataSource = this.findOriginalDataSource(
      allSources,
      dataElement
    );
    if (
      dataElement.type === DATA_ELEMENT_TYPE.CRM_QUERY ||
      (originalDataSource &&
        originalDataSource.type === DATA_ELEMENT_TYPE.CRM_QUERY &&
        dataElement.type !== DATA_ELEMENT_TYPE.ONE_FOR_ONE)
    ) {
      this.findPicklistTranslations(dataElement, originalDataSource);
    }
    return dataElement;
  }

  // listDataElements will not have fields by default
  // find and append fields from original data source
  appendOriginalDataSourceFields(allSources, dataElement) {
    return this.findOriginalDataSourceFields(
      allSources,
      dataElement,
      dataElement
    );
  }

  findOriginalDataSourceFields(allSources, currentDataSource, dataElement) {
    let originalDataSource = allSources[currentDataSource.original];
    if (
      currentDataSource.type === DATA_ELEMENT_TYPE.MERGE_LIST &&
      currentDataSource.fieldOrder
    ) {
      return this.appendDataSourceFieldsMergeList(
        currentDataSource,
        dataElement
      );
    } else if (dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS) {
      return this.getFeedbackChannelGoalsFields(dataElement);
    } else if (dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS) {
      return this.getFeedbackProductGoalsFields(dataElement);
    } else if (dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      return dataElement;
    } else if (
      dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS
    ) {
      return this.getFeedbackAccountChannelGoalsFields(dataElement);
    } else if (
      dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS
    ) {
      return this.getFeedbackAccountProductGoalsFields(dataElement);
    } else if (
      dataElement.type === DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS
    ) {
      return this.getFeedbackAccountProductMetricsFields(dataElement);
    } else if (currentDataSource.type === DATA_ELEMENT_TYPE.SALES_DATA_QUERY) {
      return this.appendStaticDataElementDataSourceFields(
        dataElement,
        DATA_ELEMENT_TYPE.SALES_DATA_QUERY
      );
    } else if (
      currentDataSource.type === DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES
    ) {
      return this.appendStaticDataElementDataSourceFields(
        dataElement,
        DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES
      );
    } else if (currentDataSource.type === DATA_ELEMENT_TYPE.CALL_ATTENDEES) {
      return this.appendStaticDataElementDataSourceFields(
        dataElement,
        DATA_ELEMENT_TYPE.CALL_ATTENDEES
      );
    } else if (
      originalDataSource &&
      this.isListDataElement(currentDataSource)
    ) {
      return this.findOriginalDataSourceFields(
        allSources,
        originalDataSource,
        dataElement
      );
    }
    dataElement.fields = currentDataSource ? currentDataSource.fields : [];
    return dataElement;
  }

  addFieldsToDataElement(dataElement, fieldArray) {
    dataElement.fields = {};
    fieldArray.forEach(field => {
      dataElement.fields[field.name] = field;
    });
    return dataElement;
  }

  appendStaticDataElementDataSourceFields(dataElement, dataElementType) {
    let fieldArray;
    switch (dataElementType) {
      case DATA_ELEMENT_TYPE.SALES_DATA_QUERY:
        fieldArray = utils.getSalesDataQueryFields();
        break;
      case DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES:
        fieldArray = utils.getAlignedTerritoriesFields();
        break;
      case DATA_ELEMENT_TYPE.CALL_ATTENDEES:
        fieldArray = utils.getCallAttendeesFields();
        break;
      default:
        fieldArray = [];
    }
    return this.addFieldsToDataElement(dataElement, fieldArray);
  }

  getFeedbackChannelGoalsFields(dataElement) {
    if (dataElement.selectedFields != null) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      this.fixFeedbackIdField(dataElement, "Channel ID");
    }
    return dataElement;
  }

  getFeedbackProductGoalsFields(dataElement) {
    if (dataElement.selectedFields != null) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      this.addFeedbackIdField(dataElement, "Channel ID");
      this.fixFeedbackIdField(dataElement, "Product ID");
    }
    return dataElement;
  }

  getFeedbackAccountChannelGoalsFields(dataElement) {
    if (dataElement.selectedFields != null) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      this.addFeedbackIdField(dataElement, "Account ID");
      this.fixFeedbackIdField(dataElement, "Channel ID");
    }
    return dataElement;
  }

  getFeedbackAccountProductGoalsFields(dataElement) {
    if (dataElement.selectedFields != null) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      this.addFeedbackIdField(dataElement, "Account ID");
      this.addFeedbackIdField(dataElement, "Channel ID");
      this.fixFeedbackIdField(dataElement, "Product ID");
    }
    return dataElement;
  }

  getFeedbackAccountProductMetricsFields(dataElement) {
    if (dataElement.selectedFields != null) {
      this.updateSelectedFieldsToFieldsDict(dataElement);
      this.addFeedbackIdField(dataElement, "Account ID");
    }
    return dataElement;
  }

  updateSelectedFieldsToFieldsDict(dataElement) {
    if (dataElement.selectedFields != null) {
      dataElement.fields = {};
      for (const value of Object.values(dataElement.selectedFields)) {
        value.dataType = value.type;
        dataElement.fields[value.name] = value;
      }
      delete dataElement.selectedFields;
    }
  }

  fixFeedbackIdField(dataElement, idName) {
    dataElement.fields[idName] = dataElement.fields["channelOrProductId"];
    delete dataElement.fields["channelOrProductId"];
  }

  addFeedbackIdField(dataElement, idName) {
    dataElement.fields[idName] = {
      name: idName,
      label : idName,
      dataType : "string",
      visible : true
    }
  }

  findPicklistTranslations(dataElement, originalDataSource) {
    if (originalDataSource) {
      for (const [fieldName, fieldInfo] of Object.entries(
        originalDataSource.fields
      )) {
        if (
          dataElement.fields[fieldName] &&
          fieldInfo.isPicklist &&
          !dataElement.fields[fieldName + TRANSLATION_TAG]
        ) {
          dataElement.fields[fieldName + TRANSLATION_TAG] = {
            label: fieldName + TRANSLATION_TAG,
            dataType: fieldInfo.dataType
          };
        }
      }
    } else {
      for (const [fieldName, fieldInfo] of Object.entries(dataElement.fields)) {
        if (
          fieldInfo.isPicklist &&
          !dataElement.fields[fieldName + TRANSLATION_TAG]
        ) {
          dataElement.fields[fieldName + TRANSLATION_TAG] = {
            label: fieldName + TRANSLATION_TAG,
            dataType: fieldInfo.dataType
          };
        }
      }
    }

    return dataElement;
  }

  appendDataSourceFieldsMergeList(originalDataSource, dataElement) {
    dataElement.fields = {};
    originalDataSource.fieldOrder.forEach(element => {
      dataElement.fields[element.label] = {
        label: element.label,
        dataType: element.fieldType
      };
    });
    return dataElement;
  }

  findOriginalDataSource(allSources, dataElement) {
    let orignalDataElement = allSources[dataElement.original];
    if (orignalDataElement && this.isListDataElement(orignalDataElement)) {
      // this is the case where a dataElement is a listDataElement but has another listDataElement as orignal data source,
      // need to find next original element that is not a listDataElement
      orignalDataElement = this.findOriginalDataSource(
        allSources,
        orignalDataElement
      );
    }
    return orignalDataElement;
  }

  isDateFormat(value) {
    // will "time" be part of this test?  TBD
    return ["date", "datetime"].includes(value ? value.toLowerCase() : "");
  }

  isComparable(value) {
    return ["string", "number", "date", "datetime"].includes(
      value ? value.toLowerCase() : ""
    );
  }

  // TODO these will be moved to another file  - work in progress
  getLocalApps() {
    return store.getters.apps;
  }
  getAppContent(appId) {
    const localApps = this.getLocalApps();
    const content = localApps ? localApps.find(el => el.uuid === appId) : null;
    if (!content) {
      console.error(`No app content found for appId ${appId}`);
      return;
    }
    return content;
  }

  updatePageMetadata(appId, pageName, data) {
    const localApps = this.getLocalApps();
    if (localApps) {
      const contentIndex = localApps.findIndex(el => el.uuid === appId);
      if (contentIndex > -1) {
        const content = localApps[contentIndex];
        content.pages = content.pages || [];
        let pageIndex = content.pages.findIndex(pg => pg.name === pageName);
        if (pageIndex > -1) {
          if (data) {
            // update
            content.pages[pageIndex] = data;
          } else {
            //remove page
            content.pages = content.pages.filter(pg => pg.name !== pageName);
            if (!content.pages.length) {
              // no pages are left, just remove pages
              delete content.pages;
            }
          }
        } else if (data) {
          // new data, add to pages array
          content.pages.push(data);
        }
        store.commit(MUTATION_NAME.UPDATE_APP, content);
      }
    }
  }
  findDataElements(dataElements, type) {
    return Object.keys(dataElements)
      .map(uuid => dataElements[uuid])
      .filter(de => de.type === type);
  }
}

export default new ExpressionBuilder();
